<template>
    <a :href="url" target="_blank" @click="trackEvent">
        <Icon icon="pdf" />
    </a>
</template>

<script>
import Icon from '@/components/Theme/Icon'
export default {
    name: 'InvoiceFile',
    props: {
        url: String
    },
    components: {
        Icon
    },
    methods: {
        trackEvent(){
            this.$sendMixpanelEvent('Invoice PDF Link Clicked');
            this.$ga.event('Pricing', 'Invoice PDF Link Click');
        }
    }
}
</script>